import { rest } from 'msw';
import { getConfig } from 'shared/config';
import { mockGetCustomerProductsList, mockGetCustomersList } from '.';

export const handlers = [
  rest.post(
    `${getConfig().netcracker?.host}${getConfig().netcracker?.graphQlEndpoint}`,
    async (req, res, ctx) => {
      const currentRequest = await req.json();
      return currentRequest.variables.individualIdFilter
        ? res(ctx.json(mockGetCustomersList()))
        : res(ctx.json(mockGetCustomerProductsList()));
    },
  ),
];
